<template>
    <div class="container">
        <b-modal 
            :model-value="modCreaRedFila" 
            :no-close-on-backdrop="true" 
            hide-footer
            centered
            size="lg"
            :title="labels.title"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            @hide="closeModal"
        >
            <div class="uniform-modal-body">
                <!-- Información principal -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.niif }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input v-model="niif" type="number" class="form-input" :placeholder="labels.placeholderNiif" />
                    </b-col>
                </b-row>

                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.descripcion }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input v-model="descripcion" type="text" maxlength="100" class="form-input" :placeholder="labels.placeholderDescripcion" />
                    </b-col>
                </b-row>

                <!-- Niveles -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.primerNivel }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input v-model="primerNivel" type="number" class="form-input" :placeholder="labels.placeholderPrimerNivel" />
                    </b-col>
                </b-row>

                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.segundoNivel }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input v-model="segundoNivel" type="number" class="form-input" :placeholder="labels.placeholderSegundoNivel" />
                    </b-col>
                </b-row>

                <!-- Configuración -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.actual }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-select v-model="actual" class="form-input">
                            <option value="">{{ labels.select }}</option>
                            <option value="1">{{ labels.yes }}</option>
                            <option value="0">{{ labels.not }}</option>
                        </b-form-select>
                    </b-col>
                </b-row>

                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.operacion }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-select v-model="operacion" class="form-input">
                            <option value="">{{ labels.select }}</option>
                            <option value="+">{{ labels.sumar }}</option>
                            <option value="-">{{ labels.restar }}</option>
                        </b-form-select>
                    </b-col>
                </b-row>

                <!-- Reporte (char(3) NOT NULL) -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.reporte }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-select v-model="reporte" class="form-input">
                            <option value="">{{ labels.select }}</option>
                            <option value="BAL">BAL</option>
                            <option value="ERI">ERI</option>
                            <option value="ESF">ESF</option>
                            <option value="EFE">EFE</option>
                            <option value="ECP">ECP</option>
                            <option value="ORI">ORI</option>
                        </b-form-select>
                    </b-col>
                </b-row>

                <!-- Pestañas de selección -->
                <b-row class="d-flex align-items-start uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.niifSelect }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <div class="tabs-container">
                            <!-- Pestañas -->
                            <div class="tabs-header">
                                <button 
                                    class="tab-button" 
                                    :class="{ active: activeTab === 'niif' }"
                                    @click="changeTab('niif')"
                                >
                                    {{ labels.tabNiif }}
                                </button>
                                <button 
                                    class="tab-button" 
                                    :class="{ active: activeTab === 'cuentas' }"
                                    @click="changeTab('cuentas')"
                                >
                                    {{ labels.tabCuentas }}
                                </button>
                                <button 
                                    class="tab-button" 
                                    :class="{ active: activeTab === 'redefiniciones' }"
                                    @click="changeTab('redefiniciones')"
                                >
                                    {{ labels.tabRedefiniciones }}
                                </button>
                            </div>

                            <!-- Contenido de pestañas -->
                            <div class="tab-content">
                                <!-- Pestaña NIIF -->
                                <div v-if="activeTab === 'niif'" class="niif-selection-container">
                                    <div class="criterio-inputs-wrapper mb-2">
                                        <b-form-input 
                                            v-model="searchNiif" 
                                            type="text" 
                                            class="form-input"
                                            style="height: 34px; font-size: 13px; margin-bottom: 6px;"
                                            :placeholder="labels.searchPlaceholder"
                                        />
                                    </div>

                                    <div class="accounts-section">
                                        <div v-if="filteredNiif.length > 0" class="accounts-list">
                                            <div class="select-all-container mb-2 d-flex align-items-center justify-content-between">
                                                <b-button 
                                                    size="sm"
                                                    style="background-color: #2e507a; border-color: #2e507a; font-size: 13px; padding: 4px 16px; border-radius: 4px; color: white;"
                                                    @click="toggleSelectAll"
                                                >
                                                    {{ selectAll ? labels.deselectAll : labels.selectAll }}
                                                </b-button>
                                                <span style="font-size: 13px; color: #6c757d;">
                                                    {{ labels.selected }}: <strong>{{ selectedNiifs?.length || 0 }}</strong> / {{ filteredNiif?.length || 0 }}
                                                </span>
                                            </div>

                                            <div class="custom-scroll-table">
                                                <table class="table table-sm table-hover" style="font-size: 13px; margin-bottom: 0;">
                                                    <thead style="position: sticky; top: 0; background: #f8f9fa; z-index: 1;">
                                                        <tr>
                                                            <th style="width: 80px; font-weight: 600; font-size: 12px; color: #495057; padding: 6px 8px;">
                                                                NIIF
                                                            </th>
                                                            <th style="font-weight: 600; font-size: 12px; color: #495057; padding: 6px 8px;">
                                                                Descripción
                                                            </th>
                                                            <th style="width: 70px; font-weight: 600; font-size: 12px; color: #495057; padding: 6px 8px;">
                                                                Nivel 1
                                                            </th>
                                                            <th style="width: 70px; font-weight: 600; font-size: 12px; color: #495057; padding: 6px 8px;">
                                                                Nivel 2
                                                            </th>
                                                            <th style="font-weight: 600; font-size: 12px; color: #495057; padding: 6px 8px;">
                                                                Desc. Nivel 2
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr 
                                                            v-for="niif in filteredNiif" 
                                                            :key="niif.id"
                                                            @click="toggleNiifSelection(niif)"
                                                            :class="{'table-active-blue': isNiifSelected(niif)}"
                                                            style="cursor: pointer;"
                                                        >
                                                            <td style="padding: 5px 8px; border-radius: 8px 0 0 8px;">
                                                                <strong>{{ niif?.niif || '' }}</strong>
                                                            </td>
                                                            <td style="padding: 5px 8px;" :title="niif.nameNiif || niif.descripcion">
                                                                {{ niif?.nameNiif || niif?.descripcion || '-' }}
                                                            </td>
                                                            <td style="padding: 5px 8px;">
                                                                {{ niif?.primer_nivel || '-' }}
                                                            </td>
                                                            <td style="padding: 5px 8px;">
                                                                {{ niif?.segundo_nivel || '-' }}
                                                            </td>
                                                            <td style="padding: 5px 8px; border-radius: 0 8px 8px 0;" :title="getSecondLevelDescription(niif.niif)">
                                                                {{ getSecondLevelDescription(niif?.niif) }}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>

                                            <div v-if="filteredNiif?.length === 0" class="text-center py-2" style="height: 150px; display: flex; align-items: center; justify-content: center;">
                                                <span class="text-muted" style="font-size: 13px;">{{ labels.noResults }}</span>
                                            </div>
                                        </div>

                                        <div v-else class="text-center py-2" style="height: 150px; display: flex; align-items: center; justify-content: center;">
                                            <span class="text-muted" style="font-size: 13px;">{{ labels.noResults }}</span>
                                        </div>
                                    </div>
                                </div>

                                <!-- Pestaña Cuentas -->
                                <div v-if="activeTab === 'cuentas'" class="cuentas-selection-container">
                                    <div class="criterio-inputs-wrapper mb-2">
                                        <b-form-input 
                                            v-model="searchCuenta" 
                                            type="text" 
                                            class="form-input"
                                            style="height: 34px; font-size: 13px; margin-bottom: 6px;"
                                            :placeholder="labels.searchCuentaPlaceholder"
                                        />
                                    </div>

                                    <div class="accounts-section">
                                        <div v-if="filteredCuentas.length > 0" class="accounts-list">
                                            <div class="select-all-container mb-2 d-flex align-items-center justify-content-between">
                                                <b-button 
                                                    size="sm"
                                                    style="background-color: #2e507a; border-color: #2e507a; font-size: 13px; padding: 4px 16px; border-radius: 4px; color: white;"
                                                    @click="toggleSelectAllCuentas"
                                                >
                                                    {{ selectAllCuentas ? labels.deselectAll : labels.selectAll }}
                                                </b-button>
                                                <span style="font-size: 13px; color: #6c757d;">
                                                    {{ labels.selected }}: <strong>{{ selectedCuentas?.length || 0 }}</strong> / {{ filteredCuentas?.length || 0 }}
                                                </span>
                                            </div>

                                            <div class="custom-scroll-table">
                                                <table class="table table-sm table-hover" style="font-size: 13px; margin-bottom: 0;">
                                                    <thead style="position: sticky; top: 0; background: #f8f9fa; z-index: 1;">
                                                        <tr>
                                                            <th style="width: 80px; font-weight: 600; font-size: 12px; color: #495057; padding: 6px 8px;">
                                                                Cuenta
                                                            </th>
                                                            <th style="font-weight: 600; font-size: 12px; color: #495057; padding: 6px 8px;">
                                                                Descripción
                                                            </th>
                                                            <th style="width: 70px; font-weight: 600; font-size: 12px; color: #495057; padding: 6px 8px;">
                                                                NIIF
                                                            </th>
                                                            <th style="font-weight: 600; font-size: 12px; color: #495057; padding: 6px 8px;">
                                                                Presentación
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr 
                                                            v-for="cuenta in filteredCuentas" 
                                                            :key="cuenta.id"
                                                            @click="toggleCuentaSelection(cuenta)"
                                                            :class="{'table-active-blue': isCuentaSelected(cuenta)}"
                                                            style="cursor: pointer;"
                                                        >
                                                            <td style="padding: 5px 8px; border-radius: 8px 0 0 8px;">
                                                                <strong>{{ cuenta?.cuenta || '' }}</strong>
                                                            </td>
                                                            <td style="padding: 5px 8px;" :title="cuenta.descripcion">
                                                                {{ cuenta?.descripcion || '-' }}
                                                            </td>
                                                            <td style="padding: 5px 8px;">
                                                                {{ cuenta?.niif || '-' }}
                                                            </td>
                                                            <td style="padding: 5px 8px; border-radius: 0 8px 8px 0;">
                                                                {{ cuenta?.presentacion || '-' }}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>

                                            <div v-if="filteredCuentas?.length === 0" class="text-center py-2" style="height: 150px; display: flex; align-items: center; justify-content: center;">
                                                <span class="text-muted" style="font-size: 13px;">{{ labels.noCuentaResults }}</span>
                                            </div>
                                        </div>

                                        <div v-else class="text-center py-2" style="height: 150px; display: flex; align-items: center; justify-content: center;">
                                            <span class="text-muted" style="font-size: 13px;">{{ labels.noCuentaResults }}</span>
                                        </div>
                                    </div>
                                </div>

                                <!-- Pestaña Redefiniciones -->
                                <div v-if="activeTab === 'redefiniciones'" class="redefiniciones-selection-container">
                                    <div class="criterio-inputs-wrapper mb-2">
                                        <b-form-input 
                                            v-model="searchRedefinicion" 
                                            type="text" 
                                            class="form-input"
                                            style="height: 34px; font-size: 13px;"
                                            :placeholder="labels.searchRedefPlaceholder"
                                            @input="filterRedefiniciones"
                                        />
                                    </div>

                                    <div class="accounts-section">
                                        <div v-if="filteredRedefiniciones.length > 0" class="accounts-list">
                                            <div class="select-all-container mb-2 d-flex align-items-center justify-content-between">
                                                <b-button 
                                                    size="sm"
                                                    style="background-color: #2e507a; border-color: #2e507a; font-size: 13px; padding: 4px 16px; border-radius: 4px; color: white;"
                                                    @click="toggleSelectAllRedef"
                                                >
                                                    {{ selectAllRedef ? labels.deselectAll : labels.selectAll }}
                                                </b-button>
                                                <span style="font-size: 13px; color: #6c757d;">
                                                    {{ labels.selected }}: <strong>{{ selectedRedefiniciones?.length || 0 }}</strong> / {{ filteredRedefiniciones?.length || 0 }}
                                                </span>
                                            </div>

                                            <div class="custom-scroll-table">
                                                <table class="table table-sm table-hover" style="font-size: 13px; margin-bottom: 0;">
                                                    <thead style="position: sticky; top: 0; background: #f8f9fa; z-index: 1;">
                                                        <tr>
                                                            <th style="width: 80px; font-weight: 600; font-size: 12px; color: #495057; padding: 6px 8px;">
                                                                NIIF
                                                            </th>
                                                            <th style="font-weight: 600; font-size: 12px; color: #495057; padding: 6px 8px;">
                                                                Descripción
                                                            </th>
                                                            <th style="width: 70px; font-weight: 600; font-size: 12px; color: #495057; padding: 6px 8px;">
                                                                Nivel 1
                                                            </th>
                                                            <th style="width: 70px; font-weight: 600; font-size: 12px; color: #495057; padding: 6px 8px;">
                                                                Nivel 2
                                                            </th>
                                                            <th style="font-weight: 600; font-size: 12px; color: #495057; padding: 6px 8px;">
                                                                Formulación
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr 
                                                            v-for="redef in filteredRedefiniciones" 
                                                            :key="redef.id"
                                                            @click="toggleRedefinicionSelection(redef)"
                                                            :class="{'table-active-blue': isRedefinicionSelected(redef)}"
                                                            style="cursor: pointer;"
                                                        >
                                                            <td style="padding: 5px 8px; border-radius: 8px 0 0 8px;">
                                                                <strong>{{ redef?.niif || '' }}</strong>
                                                            </td>
                                                            <td style="padding: 5px 8px;" :title="redef.descripcion">
                                                                {{ redef?.descripcion || '-' }}
                                                            </td>
                                                            <td style="padding: 5px 8px;">
                                                                {{ redef?.primer_nivel || '-' }}
                                                            </td>
                                                            <td style="padding: 5px 8px;">
                                                                {{ redef?.segundo_nivel || '-' }}
                                                            </td>
                                                            <td style="padding: 5px 8px; border-radius: 0 8px 8px 0;" :title="redef.formulacion">
                                                                {{ truncateFormulation(redef?.formulacion) }}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>

                                            <div v-if="filteredRedefiniciones?.length === 0" class="text-center py-2" style="height: 150px; display: flex; align-items: center; justify-content: center;">
                                                <span class="text-muted" style="font-size: 13px;">{{ labels.noRedefResults }}</span>
                                            </div>
                                        </div>

                                        <div v-else class="text-center py-2" style="height: 150px; display: flex; align-items: center; justify-content: center;">
                                            <span class="text-muted" style="font-size: 13px;">{{ labels.noRedefResults }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>

                <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
                    <b-button class="reset-btn-secondary" @click="closeDialog">
                        {{ labels.close }}
                    </b-button>
                    <b-button class="reset-btn-primary ml-2" @click="confirmSave">
                        {{ labels.save }}
                    </b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import PlanConsolidacion from '../../../services/PlanConsolidacion'; 
import RedefinicionFila from '../../../services/RedefinicionFila'; 

export default {
    name: 'CreaRedefinicionFila',
    props: ['modCreaRedFila', 'vigenciaSelected', 'codReporte'],
    data: () => ({
        niif: "",
        descripcion: "",
        primerNivel: "",
        segundoNivel: "",
        actual: "",
        operacion: "",
        reporte: "",
        niifSelect: [],
        listNiif: [],
        searchNiif: "",
        selectedNiifs: [],
        selectAll: false,
        hasUnsavedChanges: false,
        activeTab: 'niif',
        listRedefiniciones: [],
        searchRedefinicion: '',
        selectedRedefiniciones: [],
        selectAllRedef: false,
        sortColumnRedef: 'niif',
        sortDirectionRedef: 'asc',
        // Cuentas
        listCuentas: [],
        searchCuenta: '',
        selectedCuentas: [],
        selectAllCuentas: false,
    }),
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Crear fila",
                    save: "Guardar",
                    close: "Cerrar",
                    niif: "Niif",
                    descripcion: "Descripción",
                    primerNivel: "Primer nivel",
                    segundoNivel: "Segundo nivel",
                    actual: "Actual",
                    yes: "SI",
                    not: "NO",
                    operacion: "Operación",
                    sumar: "Sumar",
                    restar: "Restar",
                    reporte: "Reporte",
                    niifSelect: "Seleccionar NIIF",
                    select: "Seleccione...",
                    searchPlaceholder: "Buscar NIIF...",
                    searchCuentaPlaceholder: "Buscar cuenta...",
                    selected: "Seleccionados",
                    noResults: "No se encontraron resultados",
                    noCuentaResults: "No se encontraron cuentas",
                    tabNiif: "NIIFs",
                    tabCuentas: "Cuentas",
                    tabRedefiniciones: "Redefiniciones",
                    searchRedefPlaceholder: "Buscar redefiniciones...",
                    noRedefResults: "No se encontraron redefiniciones",
                    showing: "Mostrando",
                    formulacion: "Formulación",
                    presentacion: "Presentación",
                    selectAll: "Seleccionar todas",
                    deselectAll: "Deseleccionar todas",
                    placeholderNiif: "Ingrese NIIF",
                    placeholderDescripcion: "Ingrese descripción",
                    placeholderPrimerNivel: "Ingrese primer nivel",
                    placeholderSegundoNivel: "Ingrese segundo nivel",
                    requiredFields: "Complete todos los campos obligatorios (reporte, NIIF, descripción, niveles y operación)."
                }
            } else {
                return {
                    title: "Create row",
                    save: "Save",
                    close: "Close",
                    niif: "Niif",
                    descripcion: "Description",
                    primerNivel: "First level",
                    segundoNivel: "Second level",
                    actual: "Current",
                    yes: "YES",
                    not: "NOT",
                    operacion: "Operation",
                    sumar: "Add",
                    restar: "Subtract",
                    reporte: "Report",
                    niifSelect: "Select NIIF",
                    select: "Select...",
                    searchPlaceholder: "Search NIIF...",
                    searchCuentaPlaceholder: "Search account...",
                    selected: "Selected",
                    noResults: "No results found",
                    noCuentaResults: "No accounts found",
                    tabNiif: "NIIFs",
                    tabCuentas: "Accounts",
                    tabRedefiniciones: "Redefinitions",
                    searchRedefPlaceholder: "Search redefinitions...",
                    noRedefResults: "No redefinitions found",
                    showing: "Showing",
                    formulacion: "Formulation",
                    presentacion: "Presentation",
                    selectAll: "Select all",
                    deselectAll: "Deselect all",
                    placeholderNiif: "Enter NIIF",
                    placeholderDescripcion: "Enter description",
                    placeholderPrimerNivel: "Enter first level",
                    placeholderSegundoNivel: "Enter second level",
                    requiredFields: "Please complete all required fields (report, NIIF, description, levels and operation)."
                }
            }
        },
        filteredNiif() {
            const term = this.searchNiif?.toLowerCase() || "";
            return this.listNiif.filter(n =>
                n.niif.toString().includes(term) || 
                (n.nameNiif && n.nameNiif.toLowerCase().includes(term)) || 
                (n.descripcion && n.descripcion.toLowerCase().includes(term)) 
            );
        },
        filteredCuentas() {
            const term = this.searchCuenta?.toLowerCase() || "";
            return this.listCuentas.filter(c =>
                c.cuenta.toString().includes(term) ||
                (c.descripcion && c.descripcion.toLowerCase().includes(term))
            );
        },
        filteredRedefiniciones() {
            if (!this.searchRedefinicion) {
                return this.listRedefiniciones || [];
            }
            const term = this.searchRedefinicion.toLowerCase();
            return (this.listRedefiniciones || []).filter(item =>
                item.niif.toString().includes(term) || 
                (item.descripcion && item.descripcion.toLowerCase().includes(term)) 
            );
        }
    },
    watch: {
        niif() { this.hasUnsavedChanges = true; },
        descripcion() { this.hasUnsavedChanges = true; },
        primerNivel() { this.hasUnsavedChanges = true; },
        segundoNivel() { this.hasUnsavedChanges = true; },
        actual() { this.hasUnsavedChanges = true; },
        operacion() { this.hasUnsavedChanges = true; },
        reporte() { this.hasUnsavedChanges = true; },
        modCreaRedFila(val) {
            if (val) {
                this.loadNiif();
                this.loadCuentas();
            } else {
                this.clearFields();
            }
        }
    },
    methods: {
        // ==== Carga de datos ====
        loadNiif() {
            PlanConsolidacion.getPlanConsPorCompVige(this.vigenciaSelected, this.codReporte)
                .then((res) => {
                    this.listNiif = res.data.planConsNiif || [];
                    this.listNiif.forEach(n => n._selected = false);
                    this.selectedNiifs = [];
                    this.selectAll = false;
                })
                .catch((err) => {
                    console.log(err);
                    this.listNiif = [];
                    this.selectedNiifs = [];
                });
        },

        loadCuentas() {
            RedefinicionFila.getCuentasByVigenciaAndReporte(this.vigenciaSelected, this.codReporte)
                .then((res) => {
                    this.listCuentas = res.data.cuentas || [];
                    this.listCuentas.forEach(c => c._selected = false);
                    this.selectedCuentas = [];
                    this.selectAllCuentas = false;
                })
                .catch((err) => {
                    console.log('Error cargando cuentas:', err);
                    this.listCuentas = [];
                    this.selectedCuentas = [];
                });
        },

        // ==== Métodos para NIIF (selección por click en fila) ====
        isNiifSelected(niif) {
            if (!niif || niif.niif === undefined || niif.niif === null) return false;
            return this.selectedNiifs.some(item => String(item.niif) === String(niif.niif));
        },

        toggleNiifSelection(niif) {
            if (!niif || niif.niif === undefined || niif.niif === null) return;
            const index = this.selectedNiifs.findIndex(item => String(item.niif) === String(niif.niif));
            if (index > -1) {
                this.selectedNiifs.splice(index, 1);
                niif._selected = false;
            } else {
                this.selectedNiifs.push(niif);
                niif._selected = true;
            }
            this.updateSelectAllState();
        },

        updateSelectAllState() {
            if (this.filteredNiif.length === 0) {
                this.selectAll = false;
                return;
            }
            this.selectAll = this.filteredNiif.every(n => n._selected);
        },

        toggleSelectAll() {
            this.selectAll = !this.selectAll;
            const selectedNiifCodes = this.selectedNiifs.map(item => String(item.niif));
            
            if (this.selectAll) {
                this.filteredNiif.forEach(n => {
                    const niifStr = String(n.niif);
                    if (!selectedNiifCodes.includes(niifStr)) {
                        this.selectedNiifs.push(n);
                        n._selected = true;
                    }
                });
            } else {
                const filteredCodes = this.filteredNiif.map(n => String(n.niif));
                this.selectedNiifs = this.selectedNiifs.filter(s => !filteredCodes.includes(String(s.niif)));
                this.filteredNiif.forEach(n => n._selected = false);
            }
        },

        // ==== Métodos para Cuentas (selección por click en fila) ====
        isCuentaSelected(cuenta) {
            if (!cuenta || cuenta.id === undefined || cuenta.id === null) return false;
            return this.selectedCuentas.some(item => item.id === cuenta.id);
        },

        toggleCuentaSelection(cuenta) {
            if (!cuenta || cuenta.id === undefined || cuenta.id === null) return;
            const index = this.selectedCuentas.findIndex(item => item.id === cuenta.id);
            if (index > -1) {
                this.selectedCuentas.splice(index, 1);
                cuenta._selected = false;
            } else {
                this.selectedCuentas.push(cuenta);
                cuenta._selected = true;
            }
            this.updateSelectAllCuentasState();
        },

        updateSelectAllCuentasState() {
            if (this.filteredCuentas.length === 0) {
                this.selectAllCuentas = false;
                return;
            }
            this.selectAllCuentas = this.filteredCuentas.every(c => c._selected);
        },

        toggleSelectAllCuentas() {
            this.selectAllCuentas = !this.selectAllCuentas;
            const selectedCuentaIds = this.selectedCuentas.map(item => item.id);
            
            if (this.selectAllCuentas) {
                this.filteredCuentas.forEach(c => {
                    if (!selectedCuentaIds.includes(c.id)) {
                        this.selectedCuentas.push(c);
                        c._selected = true;
                    }
                });
            } else {
                const filteredIds = this.filteredCuentas.map(c => c.id);
                this.selectedCuentas = this.selectedCuentas.filter(s => !filteredIds.includes(s.id));
                this.filteredCuentas.forEach(c => c._selected = false);
            }
        },

        // ==== Métodos para Redefiniciones ====
        isRedefinicionSelected(redef) {
            if (!redef || redef.id === undefined || redef.id === null) return false;
            return this.selectedRedefiniciones.some(item => item.id === redef.id);
        },

        toggleRedefinicionSelection(redef) {
            if (!redef || redef.id === undefined || redef.id === null) return;
            const index = this.selectedRedefiniciones.findIndex(item => item.id === redef.id);
            if (index > -1) {
                this.selectedRedefiniciones.splice(index, 1);
                redef._selected = false;
            } else {
                this.selectedRedefiniciones.push(redef);
                redef._selected = true;
            }
            this.updateSelectAllRedefState();
            this.applyRedefinicionesSelection();
        },

        toggleSelectAllRedef() {
            this.selectAllRedef = !this.selectAllRedef;
            const selectedRedefIds = this.selectedRedefiniciones.map(item => item.id);
            
            if (this.selectAllRedef) {
                this.filteredRedefiniciones.forEach(redef => {
                    if (!selectedRedefIds.includes(redef.id)) {
                        this.selectedRedefiniciones.push(redef);
                        redef._selected = true;
                    }
                });
            } else {
                const filteredIds = this.filteredRedefiniciones.map(r => r.id);
                this.selectedRedefiniciones = this.selectedRedefiniciones.filter(s => !filteredIds.includes(s.id));
                this.filteredRedefiniciones.forEach(redef => redef._selected = false);
            }
            this.applyRedefinicionesSelection();
        },

        updateSelectAllRedefState() {
            if (this.filteredRedefiniciones.length === 0) {
                this.selectAllRedef = false;
                return;
            }
            this.selectAllRedef = this.filteredRedefiniciones.every(redef => redef._selected);
        },

        applyRedefinicionesSelection() {
            if (this.selectedRedefiniciones.length === 0) return;
            
            const allNiifCodes = new Set();
            const allCuentaCodes = new Set();

            this.selectedRedefiniciones.forEach(redef => {
                const niifCodes = this.extractNiifCodesFromFormulation(redef.formulacion);
                niifCodes.forEach(code => allNiifCodes.add(code));
                
                const cuentaCodes = this.extractCuentaCodesFromFormulation(redef.formulacion);
                cuentaCodes.forEach(code => allCuentaCodes.add(code));
            });

            const uniqueNiifCodes = Array.from(allNiifCodes);
            const uniqueCuentaCodes = Array.from(allCuentaCodes);

            this.listNiif.forEach(niif => {
                niif._selected = uniqueNiifCodes.includes(parseInt(niif.niif));
            });
            this.selectedNiifs = this.listNiif.filter(niif => niif._selected);

            this.listCuentas.forEach(cuenta => {
                cuenta._selected = uniqueCuentaCodes.includes(cuenta.presentacion);
            });
            this.selectedCuentas = this.listCuentas.filter(cuenta => cuenta._selected);

            this.updateSelectAllState();
            this.updateSelectAllCuentasState();
            this.hasUnsavedChanges = true;
        },

        clearFields() {
            this.niif = "";
            this.descripcion = "";
            this.primerNivel = "";
            this.segundoNivel = "";
            this.actual = "";
            this.operacion = "";
            this.reporte = "";
            this.niifSelect = [];
            this.listNiif = [];
            this.selectedNiifs = [];
            this.hasUnsavedChanges = false;
            this.selectAll = false;
            this.searchNiif = "";
            this.listCuentas = [];
            this.selectedCuentas = [];
            this.searchCuenta = "";
            this.selectAllCuentas = false;
            this.selectedRedefiniciones = [];
            this.listRedefiniciones = [];
            this.searchRedefinicion = '';
            this.selectAllRedef = false;
            this.activeTab = 'niif';
        },

        closeDialog() {
            if (this.hasUnsavedChanges) {
                const message = this.$store.state._language == "es-ES"
                    ? "Tienes cambios sin guardar. ¿Quieres cerrar sin guardar?"
                    : "You have unsaved changes. Do you want to close without saving?";
                    
                if (window.confirm(message)) { 
                    this.closeModal();
                }
            } else {
                this.closeModal();
            }
        },

        isFormValid() {
            return !!this.reporte
                && this.niif !== ""
                && !!this.descripcion.trim()
                && this.primerNivel !== ""
                && this.segundoNivel !== ""
                && !!this.operacion;
        },

        confirmSave() {
            if (!this.isFormValid()) {
                this.$toast.error(this.labels.requiredFields);
                return;
            }
            const message = this.$store.state._language == "es-ES"
                ? "¿Está seguro que desea crear esta fila?"
                : "Are you sure you want to create this row?";
                
            if (window.confirm(message)) { 
                this.guardaRedFila();
            }
        },

        closeModal() {
            this.$emit('cierraModal', false);
            this.clearFields();
        },

        getSecondLevelDescription(niif) {
            if (!niif) return '-';
            const level = this.listNiif.find(r_niif => r_niif.niif == niif);
            return level ? level?.nameSegundoNivel : '-';
        },

        guardaRedFila() {
            const formData = {
                codReporte: this.codReporte,   // viene del padre
                reporte: this.reporte,         // char(3)
                niif: this.niif,
                descripcion: this.descripcion,
                primerNivel: this.primerNivel,
                segundoNivel: this.segundoNivel,
                actual: this.actual,
                operacion: this.operacion,
                niifSelect: this.selectedNiifs.map(n => n.niif),
                cuentasSelect: this.selectedCuentas.map(c => c.presentacion),
                idUser: this.$store.state.userId,
            };
            
            RedefinicionFila.createRedefinicionFila(formData) 
                .then((res) => { 
                    this.$toast.success(res.data.message);
                    this.closeModal();
                    this.$emit('reload');
                })
                .catch((err) => { 
                    console.log(err); 
                    if(err.response && err.response.status == 412) { 
                        this.$toast.error(err.response.data.message);
                    }
                }); 
        },

        changeTab(tab) {
            this.activeTab = tab;
            if (tab === 'redefiniciones' && this.listRedefiniciones.length === 0) {
                this.loadRedefiniciones();
            }
            if (tab === 'redefiniciones' && this.selectedNiifs.length === 0 && this.selectedCuentas.length === 0) {
                this.clearRedefinicionesSelection();
            }
        },

        loadRedefiniciones() {
            RedefinicionFila.getAllRedefinicionFilas(this.codReporte)
                .then(res => { 
                    this.listRedefiniciones = res.data.redefinicionFila || [];
                    this.listRedefiniciones.forEach(redef => redef._selected = false);
                    this.selectedRedefiniciones = [];
                })
                .catch(err => { 
                    console.log('Error cargando redefiniciones:', err); 
                    this.listRedefiniciones = [];
                    this.selectedRedefiniciones = [];
                });
        },

        filterRedefiniciones() {
            // Este método se llama desde el input, pero filteredRedefiniciones es computed
            // No necesita hacer nada adicional
        },

        clearRedefinicionesSelection() {
            this.selectedRedefiniciones = [];
            this.listRedefiniciones.forEach(redef => redef._selected = false);
            this.selectAllRedef = false;
        },

        extractNiifCodesFromFormulation(formulation) {
            if (!formulation) return [];
            const niifMatch = formulation.match(/Niif\(([^)]+)\)/i); 
            if (niifMatch) {
                return niifMatch[1].split(',')?.map(num => parseInt(num.trim()))?.filter(num => !isNaN(num));
            }
            return formulation?.replace(/[+-]/g, ',').split(',')?.map(n => parseInt(n.trim()))?.filter(n => !isNaN(n));
        },

        extractCuentaCodesFromFormulation(formulation) {
            if (!formulation) return [];
            const cuentaMatch = formulation.match(/Cuenta\(([^)]+)\)/i);
            if (cuentaMatch) {
                return cuentaMatch[1].split(',').map(c => c.trim()).filter(c => c);
            }
            return [];
        },

        truncateFormulation(formulation) {
            if (!formulation) return '';
            if (formulation.length > 50) { 
                const niifMatch = formulation.match(/^(Niif\([^)]+\))/i); 
                if (niifMatch) {
                    const niifPart = niifMatch[1];
                    if (niifPart.length > 50) { 
                        const numbersMatch = niifPart.match(/Niif\(([^)]+)\)/i); 
                        if (numbersMatch) {
                            const numbers = numbersMatch[1].split(','); 
                            if (numbers.length > 8) { 
                                const truncatedNumbers = [
                                    ...numbers.slice(0, 5), 
                                    '...', 
                                    ...numbers.slice(-3) 
                                ].join(','); 
                                return `Niif(${truncatedNumbers})`;
                            }
                        }
                    }
                    return niifPart;
                }
                // Intentar extraer Cuenta()
                const cuentaMatch = formulation.match(/^(Cuenta\([^)]+\))/i);
                if (cuentaMatch) {
                    const cuentaPart = cuentaMatch[1];
                    if (cuentaPart.length > 50) {
                        const numbersMatch = cuentaPart.match(/Cuenta\(([^)]+)\)/i);
                        if (numbersMatch) {
                            const numbers = numbersMatch[1].split(',');
                            if (numbers.length > 8) {
                                const truncatedNumbers = [
                                    ...numbers.slice(0, 5),
                                    '...',
                                    ...numbers.slice(-3)
                                ].join(',');
                                return `Cuenta(${truncatedNumbers})`;
                            }
                        }
                    }
                    return cuentaPart;
                }
                return formulation?.substring(0, 50) + '..? ';             
            }
            return formulation;
        }
    }
}
</script>

<style src="../../main.css"></style>

<style scoped>
/* ========== ESTILOS PARA SELECTOR MÚLTIPLE ========== */
.criterio-inputs-wrapper {
    display: flex;
    flex-direction: column;
    gap: 6px;
    width: 100%;
}

.accounts-section {
    margin-top: 8px;
}

.select-all-container {
    padding: 4px 0;
}

.custom-scroll-table {
    height: 200px !important;
    min-height: 200px !important;
    max-height: 200px !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    display: block !important;
    position: relative !important;
}

.custom-scroll-table table {
    display: table !important;
    width: 100% !important;
    table-layout: fixed !important;
    margin-bottom: 0 !important;
    border-collapse: separate !important;
    border-spacing: 0 !important;
}

.custom-scroll-table table thead {
    display: table-header-group !important;
    width: 100% !important;
    position: sticky !important;
    top: 0 !important;
    z-index: 10 !important;
}

.custom-scroll-table table thead tr {
    display: table-row !important;
    width: 100% !important;
}

.custom-scroll-table table thead th {
    background-color: #f8f9fa !important;
    border-bottom: 2px solid #dee2e6 !important;
    padding: 6px 8px !important;
    font-weight: 600 !important;
    font-size: 12px !important;
    color: #495057 !important;
    position: sticky !important;
    top: 0 !important;
    z-index: 10 !important;
    text-overflow: ellipsis !important;
    overflow: hidden !important;
    white-space: nowrap !important;
}

.custom-scroll-table table tbody {
    display: table-row-group !important;
    width: 100% !important;
}

.custom-scroll-table table tbody tr {
    display: table-row !important;
    width: 100% !important;
    cursor: pointer !important;
    border-radius: 8px !important;
}

.custom-scroll-table table tbody td {
    padding: 5px 8px !important;
    border: none !important;
    text-overflow: ellipsis !important;
    overflow: hidden !important;
    white-space: nowrap !important;
    vertical-align: middle !important;
}

.custom-scroll-table table tbody td:first-child {
    border-radius: 8px 0 0 8px !important;
}

.custom-scroll-table table tbody td:last-child {
    border-radius: 0 8px 8px 0 !important;
}

.custom-scroll-table table tbody tr:hover td {
    background-color: #f5f9ff !important;
}

.custom-scroll-table::-webkit-scrollbar {
    width: 8px !important;
}

.custom-scroll-table::-webkit-scrollbar-track {
    background: #f1f1f1 !important;
    border-radius: 4px !important;
}

.custom-scroll-table::-webkit-scrollbar-thumb {
    background: #c1c1c1 !important;
    border-radius: 4px !important;
}

.custom-scroll-table::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8 !important;
}

.table-active-blue {
    background-color: #e3f0ff !important;
    border-radius: 8px !important;
}

.table-active-blue td {
    background-color: #e3f0ff !important;
}

.table-active-blue td:first-child {
    border-radius: 8px 0 0 8px !important;
}

.table-active-blue td:last-child {
    border-radius: 0 8px 8px 0 !important;
}

/* Estilos de pestañas */
.tabs-container {
    width: 100%;
    border: 1px solid #dee2e6;
    border-radius: 8px;
    overflow: hidden;
    background: white;
}

.tabs-header {
    display: flex;
    border-bottom: 1px solid #dee2e6;
    background: #f8f9fa;
}

.tab-button {
    padding: 8px 16px;
    border: none;
    background: transparent;
    font-size: 13px;
    font-weight: 500;
    color: #495057;
    cursor: pointer;
    transition: all 0.2s;
    flex: 1;
}

.tab-button:hover {
    background: #e9ecef;
}

.tab-button.active {
    background: white;
    color: #2e507a;
    border-bottom: 2px solid #2e507a;
}

.tab-content {
    padding: 12px;
}

/* Estilos generales del modal */
.uniform-modal-body {
    padding: 8px 4px 4px 4px;
}

.uniform-form-row {
    margin-bottom: 12px;
}

.uniform-label-col label {
    margin-bottom: 0;
    font-weight: 500;
    font-size: 14px;
}

.form-input {
    width: 100%;
    height: 38px;
    font-size: 14px;
    border-radius: 7px;
}

.uniform-actions-wrap {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 20px;
    padding-top: 16px;
    border-top: 1px solid #e9ecef;
}

.reset-btn-primary {
    background-color: #2e507a !important;
    border: 1px solid #2e507a !important;
    color: white !important;
    padding: 8px 24px;
    border-radius: 6px;
    font-weight: 500;
}

.reset-btn-primary:hover:not(:disabled) {
    background-color: #1f3f62 !important;
    border-color: #1f3f62 !important;
}

.reset-btn-primary:disabled {
    opacity: 0.65;
    cursor: not-allowed;
}

.reset-btn-secondary {
    background-color: #f8f9fa !important;
    border: 1px solid #ced4da !important;
    color: #495057 !important;
    padding: 8px 24px;
    border-radius: 6px;
    font-weight: 500;
}

.reset-btn-secondary:hover:not(:disabled) {
    background-color: #e9ecef !important;
    border-color: #adb5bd !important;
}

.reset-modal-header {
    background-color: #2e507a;
    color: white;
    padding: 16px 20px;
    border-radius: 8px 8px 0 0;
}

.reset-modal-title {
    font-size: 18px;
    font-weight: 600;
    margin: 0;
}

.reset-modal-body {
    padding: 24px 20px;
    background-color: #f8f9fa;
}

/* ========== RESPONSIVE ========== */
@media (max-width: 768px) {
    .custom-scroll-table {
        height: 160px !important;
        min-height: 160px !important;
        max-height: 160px !important;
    }

    .custom-scroll-table table tbody td {
        font-size: 12px !important;
        padding: 4px 6px !important;
    }

    .custom-scroll-table table thead th {
        font-size: 11px !important;
        padding: 4px 6px !important;
    }
}

@media (max-width: 576px) {
    .reset-dialog-actions {
        flex-direction: column;
    }
    
    .reset-dialog-actions .reset-btn-secondary,
    .reset-dialog-actions .reset-btn-primary {
        width: 100%;
        margin: 4px 0 !important;
    }

    .uniform-label-col {
        flex: 0 0 100%;
        max-width: 100%;
        margin-bottom: 4px;
        text-align: left !important;
    }
    
    .uniform-form-row .col-md-8 {
        flex: 0 0 100%;
        max-width: 100%;
    }

    .custom-scroll-table {
        height: 140px !important;
        min-height: 140px !important;
        max-height: 140px !important;
    }

    .custom-scroll-table table tbody td {
        font-size: 11px !important;
        padding: 3px 4px !important;
    }

    .custom-scroll-table table thead th {
        font-size: 10px !important;
        padding: 3px 4px !important;
    }
}
</style>